
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M17 18a2 2 0 002-2V7a2 2 0 00-2-2h-4.59a.999.999 0 01-.7-.29l-1.42-1.42a.999.999 0 00-.7-.29H3a2 2 0 00-2 2v11a2 2 0 002 2h14zm4-9v9a2 2 0 01-2 2H5a2 2 0 002 2h12c2.21 0 4-1.79 4-4v-7a2 2 0 00-2-2z"}})])
          )
        }
      }
    